import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  InputLabel,
  Link,
  Stack,
  Typography
} from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { CheckBoxSharp, DisabledByDefaultOutlined } from "@mui/icons-material";

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  programBoxName,
  APPLY_LOAN,
  getXsValue,
  fapViewProgram,
  loanDisclaimer,
  getBarContainerHeight,
  fapViewProgramFP
} from "../../shared/constants";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment/moment";

const styles = {
  page: {
    backgroundColor: "#FFF",
    paddingHorizontal: "30px",
    paddingVertical: "50px",
    fontFamily: "Roboto"
  },

  text_regular: {
    fontSize: "14px",
    fontWeight: 400,
    width: "100%",
    textAlign: "center"
  },

  row: {
    display: "flex",
    flexDirection: "row"
  },
  row_new: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },

  fap_header: {
    backgroundColor: "#ECF7F7",
    width: "100%",
    textAlign: "center"
  },
  fap_logo: {
    marginVertical: 20
    //width: "150px",
    //alignSelf: "center"
  },
  updatedColor: {
    color: "#1BA3AD !important"
  }
};

const FapView = (props) => {
  const fapCardsStore = useSelector((state) => state.estimateReducer.fapList);
  const {
    setBoxName,
    clearBox,
    cardData,
    /* getProgramId, */ handleProgramSelect,
    practiceData,
    profileData
  } = props;
  console.log("here");
  const [isRefundProgram, setIsRefundProgram] = useState(false);
  const [isNonRefundProgram, setIsNonRefundProgram] = useState(false);
  const [isSingleCycle, setIsSingleCycle] = useState(false);
  const [isSingleCycleSelected, setPerCycleBoxSeleted] = useState(false);
  const [xsValue, setXsValue] = useState(4);
  const [fapData, setFapData] = useState({});
  const [barContainerHeight, setBarContainerHeight] = useState();
  const xsFpValue = 4;
  const [programMaxPrice, getProgramMaxPrice] = useState(0);

  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const is90DaysOrMore = (publishDate, gdmEndDate) => {
    if (!publishDate) return false;

    const published = moment(publishDate);
    if (!published.isValid()) return false;

    // Condition 1: Is estimate 91+ days old?
    const isExpiredPublished = moment().diff(published, "days") >= 91;

    // Condition 2: Was GDM active at publish time but ended now?
    const gdmExpired = gdmEndDate
      ? moment(gdmEndDate).isBefore(moment()) // GDM end date is in the past
      : false;

    return isExpiredPublished && gdmExpired;
  };

  useEffect(() => {
    if (clearBox) {
      setBoxName("");
      const updatedPrograms = fapCardsStore.programVisualization.map((item) => ({
        ...item,
        selected: false,
        programs: item.programs.map((item) => ({
          ...item,
          selected: false
        }))
      }));
      setFapData({ ...fapCardsStore, programVisualization: updatedPrograms });
    }
  }, [clearBox]);
  useEffect(() => {
    if (fapCardsStore?.programVisualization) {
      setFapData(fapCardsStore);
      fapCardsStore.programVisualization.map((item) => {
        if (item.boxName == programBoxName.PAY_PER_CYCLE && item.programs.length > 3) {
          let height = getBarContainerHeight(item.programs.length);
          setBarContainerHeight(height);
        }
        if (
          item.boxName == programBoxName.REFUND_PROGRAM &&
          props?.cardData?.refundApplicationStatus != "Rejected Not Medically Appropriate" &&
          props?.cardData?.refundApplicationStatus != "Rejected Incomplete"
        ) {
          setIsRefundProgram(true);
        }
        if (item.boxName == programBoxName.NON_REFUND_PROGRAM) {
          setIsNonRefundProgram(true);
        }
        if (item.boxName == programBoxName.PAY_PER_CYCLE) {
          setIsSingleCycle(true);
        }
        let totalLength = fapCardsStore?.programVisualization.length;
        //let mcpShowEstimate = props?.cardData?.mcpShowEstimate;
        if (
          props?.cardData?.refundApplicationStatus === "Rejected Not Medically Appropriate" ||
          props?.cardData?.refundApplicationStatus === "Rejected Incomplete" ||
          props?.cardData?.refundApplicationStatus === "Application Withdrawn" ||
          props?.cardData?.mcpShowEstimate === false
        ) {
          totalLength = totalLength - 1;
        }
        let count = getXsValue(totalLength);
        setXsValue(count);
        let pMaxPrice = getMaxProgramPrice(fapCardsStore);
        getProgramMaxPrice(pMaxPrice);
      });
    }
  }, [fapCardsStore]);

  const getMaxProgramPrice = (data) => {
    if (
      !data ||
      !Array.isArray(data.programVisualization) ||
      data.programVisualization.length === 0
    ) {
      return 0;
    }

    return data.programVisualization.reduce((maxPrice, box) => {
      if (Array.isArray(box.programs)) {
        box.programs.forEach((program) => {
          const price = Number(program.programPrice) || 0;
          if (price > maxPrice) {
            maxPrice = price;
          }
        });
      }
      return maxPrice;
    }, 0);
  };

  const abbreviateNumber = (value) => {
    var newValue = value;
    if (value >= 1000) {
      var suffixes = ["", "K", "m", "b", "t"];
      var suffixNum = Math.floor(Math.log10(value) / 3);
      var shortValue = newValue / Math.pow(10, 3 * suffixNum);
      // if (suffixNum > 3) {
      shortValue = shortValue.toFixed(1);
      // }
      return shortValue + suffixes[suffixNum];
    }
    return value;
  };

  const getProgramsPrice = (item) => {
    let programmFess = item && item.programs && item.programs[0] && item.programs[0].programPrice;
    let programRange =
      item &&
      item.programs &&
      item.programs[item.programs.length - 1] &&
      item.programs[item.programs.length - 1].programPrice;
    return item.programs.length > 1 && item.boxName != programBoxName.PAY_PER_CYCLE
      ? "$" + abbreviateNumber(programmFess) + " - " + "$" + abbreviateNumber(programRange)
      : "$" + programmFess.toLocaleString("en");
  };
  const getFPSingleProgramsPrice = (item, numberOfCycle = 1) => {
    let programmFees =
      item &&
      item.programs &&
      item.programs[item.programs.length - 1] &&
      item.programs[item.programs.length - 1].programPrice &&
      item.programs[item.programs.length - 1].programPrice;

    let singleProgramFees = programmFees * numberOfCycle;
    return "$" + singleProgramFees.toLocaleString("en");
  };

  const getSelectedProgramPrices = (data) => {
    let assure20Price, assure30Price, oneCyclePrice;

    data?.programVisualization?.forEach((box) => {
      box?.programs?.forEach((program) => {
        if (program.programName.toLowerCase() === "assure 20") {
          assure20Price = "$" + program.programPrice.toLocaleString("en");
        } else if (program.programName.toLowerCase() === "assure 30") {
          assure30Price = "$" + program.programPrice.toLocaleString("en");
        } else if (program.programName.toLowerCase() === "1 cycle") {
          oneCyclePrice = "$" + program.programPrice.toLocaleString("en");
        }
      });
    });

    return { assure20Price, assure30Price, oneCyclePrice };
  };

  const { assure20Price, assure30Price, oneCyclePrice } = getSelectedProgramPrices(fapCardsStore);

  const getRetrievals = (item) => {
    return item.boxName != programBoxName.PAY_PER_CYCLE && item.programs.length > 1
      ? item.programs[0].noOfCycle + "-" + item.programs[item.programs.length - 1].noOfCycle
      : item.programs[0].noOfCycle;
  };

  const handleBarClick = (index, barIndex, boxName) => {
    if (boxName.toLocaleLowerCase() === programBoxName.PAY_PER_CYCLE.toLocaleLowerCase()) {
      setPerCycleBoxSeleted(true);
    } else {
      setPerCycleBoxSeleted(false);
    }
    setBoxName("");
    const updatedPrograms = fapCardsStore.programVisualization.map((item) => ({
      ...item,
      selected: false,
      programs: item.programs.map((item) => ({
        ...item,
        selected: false
      }))
    }));
    setFapData({ ...fapCardsStore, programVisualization: updatedPrograms });
    setFapData((prev) => {
      const programVisualization = [...prev.programVisualization];
      programVisualization[index] = { ...programVisualization[index], selected: true };
      const programs = { ...programVisualization[index] };
      programs.programs[barIndex] = { ...programs.programs[barIndex], selected: true };
      return { programVisualization };
    });
  };

  const handleProgramClick = (item, fapCardsStore) => {
    // getProgramId(item);
    // setBoxName(item);
    handleProgramSelect(item, fapCardsStore);
  };
  console.log("cardData", cardData);
  const showFPProgramApplication = () => {
    console.log("cardData", cardData);
    const {
      treatmentType = "",
      mcpShowEstimate,
      assure20MinAge = 0,
      assure20MaxAge = 0,
      assure30MinAge = 0,
      assure30MaxAge = 0,
      refundApplicationStatus
      //refundApplicationStatus
    } = cardData ?? {};

    let isShow = true;

    if (treatmentType.toUpperCase() !== "FP") {
      isShow = false;
    }

    // Condition 3: user has not hidden the option via fapVisibilityData flag
    if (mcpShowEstimate === false) {
      isShow = false;
    }

    const patientAge = Math.floor(profileData?.personAge ?? 0);

    // Condition 2: application must NOT be "Rejected Not Medically Appropriate"
    if (
      refundApplicationStatus === "Rejected Not Medically Appropriate" ||
      refundApplicationStatus === "Rejected Incomplete" ||
      refundApplicationStatus === "Application Withdrawn" ||
      (refundApplicationStatus &&
        (refundApplicationStatus.toLowerCase() === "rejected not medically appropriate" ||
          refundApplicationStatus.toLowerCase() === "rejected incomplete" ||
          refundApplicationStatus.toLowerCase() === "application withdrawn"))
    ) {
      isShow = false;
    }

    // Condition 4: age must fall within defined ranges
    const within20s = patientAge >= assure20MinAge && patientAge <= assure20MaxAge;
    const within30s = patientAge >= assure30MinAge && patientAge <= assure30MaxAge;
    if (!within20s && !within30s) {
      isShow = false;
    }

    console.log("isShow", isShow);
    return isShow;
  };

  const showAssureProgram = () => {
    const {
      assure20MinAge = 0,
      assure20MaxAge = 0,
      assure30MinAge = 0,
      assure30MaxAge = 0,
      refundApplicationStatus
    } = cardData ?? {};
    const patientAge = Math.floor(profileData?.personAge ?? 0);

    // Condition 2: application must NOT be "Rejected Not Medically Appropriate"
    if (
      refundApplicationStatus === "Rejected Not Medically Appropriate" ||
      refundApplicationStatus === "Rejected Incomplete" ||
      refundApplicationStatus === "Application Withdrawn"
    ) {
      return false;
    }

    // Condition 4: age must fall within defined ranges
    const within20s = patientAge >= assure20MinAge && patientAge <= assure20MaxAge;
    const within30s = patientAge >= assure30MinAge && patientAge <= assure30MaxAge;

    return within20s || within30s;
  };

  const showRefundProgramApplication = () => {
    const patientAge = Math.floor(profileData?.personAge ?? 0);

    const {
      //treatmentType = "",
      donorMinAge = 0,
      donorMaxAge = 0,
      nonDonorMinAge = 0,
      nonDonorMaxAge = 0,
      mcpShowEstimate,
      refundApplicationStatus
    } = cardData ?? {};

    console.log("mcpShowEstimate", mcpShowEstimate);

    // Condition 2: application must NOT be rejected/withdrawn
    if (
      refundApplicationStatus === "Rejected Not Medically Appropriate" ||
      refundApplicationStatus === "Rejected Incomplete" ||
      refundApplicationStatus === "Application Withdrawn"
    )
      return false;

    // Condition 3: user has not hidden the option via fapVisibilityData flag
    if (mcpShowEstimate === false) return false;

    // Condition 4: age must fall within defined ranges
    const within20s = patientAge >= donorMinAge && patientAge <= donorMaxAge;
    const within30s = patientAge >= nonDonorMinAge && patientAge <= nonDonorMaxAge;

    return within20s || within30s;
  };

  const renderCards = (item, barDirection, barHeight, alignSelf, index, containerHeight) => {
    if (cardData?.treatmentType.toString().toLowerCase().includes("ivf")) {
      return (
        <>
          <Stack className="mt-16  min-h-103">
            <Typography sx={{ my: 1, fontWeight: 500 }}>
              {item.boxName === "Non-Refund Program"
                ? "Multi-Cycle Discount Program"
                : item.boxName}
            </Typography>
            <Grid container>
              <Grid item xs={12} lg={9}>
                <Typography variant="body2">
                  {item.boxName === programBoxName.PAY_PER_CYCLE
                    ? getProgramsPrice(item) + " for 3 IVF + 3 FET cycles "
                    : getProgramsPrice(item) + " for whole program"}
                </Typography>
                {item.boxName == programBoxName.PAY_PER_CYCLE && (
                  <Typography variant="body2">
                    {"$" +
                      fapCardsStore?.originalTpPrice?.toLocaleString("en") +
                      " per IVF cycle + " +
                      "$" +
                      fapCardsStore?.globalPriceOfFet?.toLocaleString("en") +
                      " per FET cycle"}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <div style={{ minHeight: 48 }}>
              <InputLabel sx={{ my: 1 }}>
                {(fapViewProgram &&
                  fapViewProgram[item.boxName] &&
                  fapViewProgram[item.boxName].programLabel1) ||
                  ""}
              </InputLabel>
              <InputLabel sx={{ my: 1 }}>
                {(fapViewProgram &&
                  fapViewProgram[item.boxName] &&
                  fapViewProgram[item.boxName].programLabel) ||
                  ""}
              </InputLabel>
            </div>
          </Stack>
          <Box className="program-summary-container">
            <Stack
              className="program-summary"
              sx={{
                backgroundColor: "#818294",
                color: "#FFF"
              }}>
              <Typography variant="caption" className="font-w-500">
                Program Summary
              </Typography>
              <li>
                <Typography variant="caption" pl={1}>
                  {fapViewProgram &&
                    fapViewProgram[item.boxName] &&
                    fapViewProgram[item.boxName].programSummary}
                </Typography>
              </li>
              <li>
                <Typography variant="caption" pl={1}>
                  {fapViewProgram &&
                    fapViewProgram[item.boxName] &&
                    fapViewProgram[item.boxName].discountStr}
                </Typography>
              </li>
            </Stack>
            {/* bar-box ${alignSelf} card-border-new */}
            <Box
              className={"bar-container " + barDirection}
              sx={{
                minHeight: barContainerHeight,
                paddingBottom: "3px",
                paddingTop: "3px"
              }}>
              <div
                className={
                  (item.boxName.toLowerCase() === programBoxName.PAY_PER_CYCLE.toLowerCase() &&
                    isSingleCycleSelected &&
                    "bar-container " + barDirection + " card-border-new-3") ||
                  "bar-container " + barDirection
                }>
                {item.programs.map((barItem, barIndex) => {
                  let disableRefundBars = false;
                  // let disableRefundBars = true;
                  barHeight = `calc(${
                    (Number(barItem.programPrice) / Number(programMaxPrice)) * 100
                  }%)`;
                  if (item.boxName === programBoxName.PAY_PER_CYCLE) {
                    let perBoxHeight = 100 / item.programs.length;
                    barHeight = `${perBoxHeight}%`;
                  }
                  if (
                    item.boxName === programBoxName.REFUND_PROGRAM &&
                    !(
                      cardData.refundApplicationStatus == "Submitted Approved" ||
                      cardData.refundApplicationStatus == "Medically Cleared"
                    )
                    // (cardData.refundApplicationStatus == "Submitted Denied" ||
                    //   cardData.refundApplicationStatus == "Submitted Need Clinical Review")
                  ) {
                    disableRefundBars = true;
                  }
                  if (is90DaysOrMore(cardData?.publishedDate, cardData?.gdmEndDate)) {
                    disableRefundBars = true;
                  }
                  let pNames = [];

                  if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "multi-cycle discount program 2+"
                  ) {
                    pNames = ["2 IVF Cycles", "Unlimited FETs"];
                  } else if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "multi-cycle discount program 3+"
                  ) {
                    pNames = ["3 IVF Cycles", "Unlimited FETs"];
                  } else if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "50% refund program 2+"
                  ) {
                    pNames = ["2 IVF Cycles", "Unlimited FETs", "50% Refund"];
                  } else if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "100% refund program 3+"
                  ) {
                    pNames = ["3 IVF Cycles", "Unlimited FETs", "100% Refund"];
                  }
                  {
                    console.log(containerHeight);
                  }
                  return (
                    <>
                      {" "}
                      <Box
                        onClick={() => {
                          if (!disableRefundBars) {
                            handleBarClick(index, barIndex, item.boxName);
                          }
                        }}
                        className={
                          disableRefundBars
                            ? `bar-box ${alignSelf}  disabled-box`
                            : barItem.selected && !isSingleCycleSelected
                            ? `bar-box ${alignSelf} card-border-new`
                            : `bar-box ${alignSelf} `
                        }
                        sx={{
                          height: barHeight,
                          backgroundColor: !disableRefundBars && "#1BA3AD",
                          color: !disableRefundBars && "#FFF",
                          width: barItem.programName.length >= 32 ? 90 : 90
                        }}>
                        {item.boxName != programBoxName.PAY_PER_CYCLE ? (
                          <Checkbox
                            className="estimate-checkbox"
                            icon={
                              <CheckCircleOutlineOutlinedIcon
                                color={barItem.selected ? "primary" : ""}
                              />
                            }
                            checkedIcon={<CheckCircleOutlineOutlinedIcon />}
                            disabled
                          />
                        ) : null}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ textAlign: "center", fontSize: 13, lineHeight: "14px" }}>
                            {"$" + Math.round((barItem.programPrice / 1000) * 10) / 10}K
                          </div>

                          <div>
                            {pNames && pNames.length ? (
                              pNames.map((pName, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      flexDirection: "column",
                                      display: "flex",
                                      margin: 1,
                                      padding: 1,
                                      fontSize: 10,
                                      lineHeight: "11px",
                                      justifyContent: "space-between"
                                    }}>
                                    {pName}
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                style={{
                                  flexDirection: "column",
                                  display: "flex",
                                  margin: 1,
                                  padding: 1,
                                  fontSize: 10,
                                  lineHeight: "11px",
                                  justifyContent: "space-between"
                                }}>
                                {barItem.programName}
                              </div>
                            )}
                          </div>
                        </div>
                      </Box>
                    </>
                  );
                })}
              </div>
            </Box>
            <Stack className="align-center">
              {
                <Button
                  fullWidth
                  onClick={() => handleProgramClick(item, fapCardsStore)}
                  variant="contained"
                  disabled={item.selected ? false : true}
                  className="program-btn"
                  sx={{ backgroundColor: "#1BA3AD", color: "#FFF" }}>
                  {item.boxName == programBoxName.PAY_PER_CYCLE
                    ? "Select Single Cycle "
                    : item.boxName == programBoxName.REFUND_PROGRAM
                    ? "Select The Refund Program"
                    : "Select The Multi-Cycle Discount Program"}
                </Button>
              }
            </Stack>
          </Box>
        </>
      );
    } else if (
      cardData?.treatmentType.toString().toLowerCase().includes("fp") &&
      showFPProgramApplication()
    ) {
      return (
        <>
          <Stack className="mt-16  min-h-103">
            <Typography sx={{ my: 1, fontWeight: 500 }}>
              {item.boxName === programBoxName.NON_REFUND_PROGRAM
                ? "Assure Programs"
                : item.boxName}
            </Typography>
            <Grid container>
              <Grid item xs={12} lg={9}>
                <Typography variant="body2">
                  {item.boxName === programBoxName.PAY_PER_CYCLE
                    ? getProgramsPrice(item) +
                      " for " +
                      item?.programs?.length +
                      " Egg Freezing Cycles "
                    : getProgramsPrice(item) + ""}
                </Typography>
                {item.boxName == programBoxName.PAY_PER_CYCLE && (
                  <Typography variant="body2">
                    {getFPSingleProgramsPrice(item) + " per Egg Freezing Cycle"}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <div>
              <InputLabel sx={{ my: 1 }}>
                {(fapViewProgramFP &&
                  fapViewProgramFP[item.boxName] &&
                  fapViewProgramFP[item.boxName].programLabel1) ||
                  ""}
              </InputLabel>
              <InputLabel sx={{ my: 1 }}>
                {(fapViewProgramFP &&
                  fapViewProgramFP[item.boxName] &&
                  fapViewProgramFP[item.boxName].programLabel) ||
                  ""}
              </InputLabel>
            </div>
          </Stack>
          <Box className="program-summary-container">
            <Stack
              className="program-summary"
              sx={{
                backgroundColor: "#818294",
                color: "#FFF"
              }}>
              <Typography variant="caption" className="font-w-500">
                Pay Per Cycle Summary
              </Typography>
              <li>
                <Typography variant="caption" pl={1}>
                  {fapViewProgramFP &&
                    fapViewProgramFP[item.boxName] &&
                    fapViewProgramFP[item.boxName].programSummary}
                </Typography>
              </li>
              <li>
                <Typography variant="caption" pl={1}>
                  {fapViewProgramFP &&
                    fapViewProgramFP[item.boxName] &&
                    fapViewProgramFP[item.boxName].discountStr}
                </Typography>
              </li>
            </Stack>
            {/* bar-box ${alignSelf} card-border-new */}
            <Box
              className={"bar-container " + barDirection}
              sx={{
                minHeight: barContainerHeight,
                paddingBottom: "3px",
                paddingTop: "3px"
              }}>
              <div
                className={
                  (item.boxName.toLowerCase() === programBoxName.PAY_PER_CYCLE.toLowerCase() &&
                    isSingleCycleSelected &&
                    "bar-container " + barDirection + " card-border-new-3") ||
                  "bar-container " + barDirection
                }>
                {item.programs.map((barItem, barIndex) => {
                  let disableRefundBars = false;
                  barHeight = `calc(${
                    (Number(barItem.programPrice) / Number(programMaxPrice)) * 100
                  }%)`;
                  if (item.boxName === programBoxName.PAY_PER_CYCLE) {
                    let perBoxHeight = 100 / item.programs.length;
                    barHeight = `${perBoxHeight}%`;
                  }

                  if (
                    item.boxName === programBoxName.NON_REFUND_PROGRAM &&
                    !(
                      cardData.refundApplicationStatus == "Submitted Approved" ||
                      cardData.refundApplicationStatus == "Medically Cleared"
                    )
                  ) {
                    disableRefundBars = true;
                  }
                  if (
                    item.boxName === programBoxName.NON_REFUND_PROGRAM &&
                    (cardData.refundApplicationStatus === "Incomplete" ||
                      cardData.refundApplicationStatus?.toLowerCase() === "incomplete")
                  ) {
                    disableRefundBars = true;
                  }
                  if (is90DaysOrMore(cardData?.publishedDate, cardData?.gdmEndDate)) {
                    disableRefundBars = true;
                  }
                  let pNames = [];

                  if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "assure 20"
                  ) {
                    pNames = ["Up to 4 cycles", "20 frozen eggs"];
                  } else if (
                    barItem &&
                    barItem.programName &&
                    barItem.programName.trim().toLowerCase() == "assure 30"
                  ) {
                    pNames = ["Up to 5 cycles", "30 frozen eggs"];
                  }

                  return (
                    <>
                      {" "}
                      <Box
                        onClick={() => {
                          if (!disableRefundBars) {
                            handleBarClick(index, barIndex, item.boxName);
                          }
                        }}
                        className={
                          disableRefundBars
                            ? `bar-box ${alignSelf}  disabled-box`
                            : barItem.selected && !isSingleCycleSelected
                            ? `bar-box ${alignSelf} card-border-new`
                            : `bar-box ${alignSelf} `
                        }
                        sx={{
                          height: barHeight,
                          backgroundColor: !disableRefundBars && "#1BA3AD",
                          color: !disableRefundBars && "#FFF",
                          width: 90
                        }}>
                        {item.boxName != programBoxName.PAY_PER_CYCLE ? (
                          <Checkbox
                            className="estimate-checkbox"
                            icon={
                              <CheckCircleOutlineOutlinedIcon
                                color={barItem.selected ? "primary" : ""}
                              />
                            }
                            checkedIcon={<CheckCircleOutlineOutlinedIcon />}
                            disabled
                          />
                        ) : null}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ textAlign: "center", fontSize: 13, lineHeight: "14px" }}>
                            {"$" + Math.round((barItem.programPrice / 1000) * 10) / 10}K
                          </div>

                          <div>
                            {pNames && pNames.length ? (
                              pNames.map((pName, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      flexDirection: "column",
                                      display: "flex",
                                      margin: 1,
                                      padding: 1,
                                      fontSize: 10,
                                      lineHeight: "11px",
                                      justifyContent: "space-between"
                                    }}>
                                    {pName}
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                style={{
                                  flexDirection: "column",
                                  display: "flex",
                                  margin: 1,
                                  padding: 1,
                                  fontSize: 10,
                                  lineHeight: "11px",
                                  justifyContent: "space-between"
                                }}>
                                {barItem.programName}
                              </div>
                            )}
                          </div>
                        </div>
                      </Box>
                    </>
                  );
                })}
              </div>
            </Box>
            <Stack className="align-center">
              {
                <Button
                  fullWidth
                  onClick={() => handleProgramClick(item, fapCardsStore)}
                  variant="contained"
                  disabled={item.selected ? false : true}
                  className="program-btn"
                  sx={{ backgroundColor: "#1BA3AD", color: "#FFF" }}>
                  {item.boxName == programBoxName.PAY_PER_CYCLE
                    ? "Select Single Cycle "
                    : item.boxName == programBoxName.REFUND_PROGRAM
                    ? "Select The Refund Program"
                    : "Select The Assure Program"}
                </Button>
              }
            </Stack>
          </Box>
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      {cardData?.treatmentType.toString().toLowerCase().includes("ivf") ||
      showFPProgramApplication() ? (
        <>
          {" "}
          <Stack className="add-to-practice align-center p-8 mx-8">
            <Typography variant="body2">
              Next Steps: Select Program Options below prior to starting treatment
            </Typography>
          </Stack>
          <Box>
            <Box>
              <Card elevation={0} variant="outlined">
                <div style={styles.row}>
                  <div style={styles.fap_header}>
                    <img alt="" style={styles.fap_logo} src="/Assets/fap-removebg.png" />

                    <div style={styles.fav_devider}></div>
                    <div style={{ flexDirection: "row", display: "flex", marginBottom: 10 }}>
                      <Typography sx={styles.text_regular}>
                        {cardData?.treatmentType.toString().toLowerCase().includes("ivf")
                          ? "We partner with Fertility Access to offer Multi-Cycle Discount and Refund Programs"
                          : "We have partnered with Fertility Access to provide Multi-Cycle Discount programs for patients with limited or no insurance coverage"}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: 10,
                        alignItems: "center"
                      }}>
                      <Typography sx={styles.text_regular}>
                        Contact the Patient Concierge team for more information on these valuable
                        offerings
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: 10,
                        alignItems: "center"
                      }}>
                      <Typography sx={styles.text_regular}>
                        patientconcierge@fertilityaccessprogram.com (800) 873-9203
                      </Typography>
                    </div>
                  </div>
                </div>
                <Stack sx={styles.row_new}>
                  {cardData?.treatmentType.toString().toLowerCase().includes("ivf") ? (
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "center",
                        fontSize: 13,
                        fontWeight: 400,
                        marginLeft: "10%",
                        marginRight: "10%",
                        width: "60%",
                        marginTop: 2
                      }}>
                      Even with state-of-the-art technology and the best treatment available, it
                      often takes women more than one IVF cycle to be successful. You may increase
                      your likelihood of having a baby when you commit to multiple cycles, so we
                      offer Refund and Multi-Cycle packages for a fixed, discounted fee that can
                      make paying for treatment more manageable.
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "center",
                        fontSize: 13,
                        fontWeight: 400,
                        margin: "0px",
                        // marginRight: "10%",
                        width: "60%",
                        marginTop: 2
                      }}>
                      <h3>Egg Freezing Takes Planning - We Help Make It Predictable</h3>
                      Reaching your egg freezing goals may take more than one cycle - but the cost
                      shouldn’t hold you back. The Fertility Access Assure Program
                      <br /> offers multiple egg freezing cycles at a reduced, fixed price, so you
                      can move forward with a clear plan and less financial stress.
                      <br /> Whether you need one cycle or more, Assure gives you the flexibility
                      and confidence to stay on track - without worrying about rising costs
                      <br /> along the way. It’s peace of mind as you take this important step for
                      your future.
                      <br />
                      More freedom. More flexibility. One predictable price.
                    </Typography>
                  )}
                </Stack>
                <Box className="p-8 mt-8">
                  {cardData?.treatmentType.toString().toLowerCase().includes("ivf") && (
                    <Stack className="align-center">
                      <img alt="" src="/Assets/group-2.png" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          paddingTop: 10
                        }}>
                        <div style={{ fontSize: 30, paddingRight: 10 }}>80%</div>
                        <div style={{ width: 300 }}>
                          of patients who enroll in a Fertility Access Program bring home a baby*
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          paddingTop: 20
                        }}></div>
                    </Stack>
                  )}
                </Box>
                {!isRefundProgram &&
                  is90DaysOrMore(cardData?.publishedDate, cardData?.gdmEndDate) && (
                    <Stack sx={styles.row_new}>
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize: 14,
                          fontWeight: 400,
                          marginLeft: "10%",
                          marginRight: "10%",
                          width: "60%",
                          marginTop: 2,
                          color: "red"
                        }}>
                        THIS ESTIMATE HAS EXPIRED. PLEASE CALL YOUR FINANCIAL COUNSELOR AT
                        <br />
                        {practiceData?.phoneNumber} TO REQUEST A NEW ESTIMATE.
                      </Typography>
                    </Stack>
                  )}
                <Box className="p-8 mt-8">
                  <Stack
                    style={{
                      justifyContent: "space-between",
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "5px"
                    }}>
                    <Typography className="p-8">
                      Highlight the option that works best for you and click the Select button.
                    </Typography>
                  </Stack>
                </Box>

                <Grid container columnSpacing={1} p="4px" className="pad-t-0">
                  {isRefundProgram && showRefundProgramApplication() ? (
                    <Grid container columnSpacing={1} p="4px" className="pad-b-0">
                      <Grid item xs={12} lg={xsValue}>
                        <Stack py={3} sx={{ background: "#1BA3AD" }}>
                          <Typography className="effective-text">
                            {"Ultimate peace of mind".toUpperCase()}
                          </Typography>
                        </Stack>
                      </Grid>
                      {/* <Grid item xs={12} lg={4}></Grid> */}
                      <Grid
                        item
                        xs={12}
                        lg={4}
                        sx={{ display: "flex", justifyContent: "-moz-initial" }}>
                        {is90DaysOrMore(cardData?.publishedDate) &&
                          new Date(cardData?.gdmEndDate || new Date()) < new Date() && (
                            <Stack sx={styles.row_new}>
                              <Typography
                                variant="body2"
                                sx={{
                                  textAlign: "center",
                                  fontSize: 12,
                                  marginLeft: "5%",
                                  color: "red"
                                }}>
                                THIS ESTIMATE HAS EXPIRED. PLEASE CALL YOUR FINANCIAL COUNSELOR AT{" "}
                                {practiceData?.phoneNumber} TO REQUEST A NEW ESTIMATE.
                              </Typography>
                            </Stack>
                          )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={4}
                        sx={{ display: "flex", justifyContent: "flex-end" }}>
                        {/* https://secure1.capexmd.com:4443/LoanApplicationSystem/usf-prequalification-request.php */}
                        <Link
                          href={APPLY_LOAN}
                          underline="none"
                          className="link-text"
                          target="_blank"
                          style={{ paddingRight: 20, paddingTop: 24 }}>
                          Click here to apply for a loan and determine potential monthly costs.
                        </Link>
                      </Grid>
                    </Grid>
                  ) : null}
                  {console.log("fapData", fapData)}
                  {fapData?.programVisualization &&
                    fapData?.programVisualization.map((item, index) => {
                      let barHeight = 95;
                      let containerHeight = 125;
                      let barDirection =
                        item.boxName == programBoxName.PAY_PER_CYCLE ? "bar-direction" : null;
                      let alignSelf =
                        item.boxName == programBoxName.PAY_PER_CYCLE ? "alignSelf" : null;
                      if (item.boxName == programBoxName.PAY_PER_CYCLE) {
                        item.programs.sort((a, b) => {
                          return b.programPrice - a.programPrice;
                        });
                      }

                      let isShow = "block";

                      let showRefundBox = showRefundProgramApplication();

                      let showAssurBox = showAssureProgram();
                      //console.log("==>abc", showAssurBox, showRefundBox);

                      if (item.boxName == programBoxName.REFUND_PROGRAM && !showRefundBox) {
                        isShow = "none";
                      }
                      if (
                        item.boxName == programBoxName.NON_REFUND_PROGRAM &&
                        !showAssurBox &&
                        cardData?.treatmentType === "FP"
                      ) {
                        isShow = "none";
                      }

                      return (
                        <>
                          <Grid
                            item
                            key={index}
                            xs={12}
                            lg={xsValue}
                            style={{ marginBottom: "5px", marginTop: "5px", display: isShow }}>
                            <Card variant="outlined" className={"p-8 card-border bt-radius-0"}>
                              {renderCards(
                                item,
                                barDirection,
                                barHeight,
                                alignSelf,
                                index,
                                containerHeight
                              )}
                            </Card>
                          </Grid>

                          {isMobileView ? (
                            <>
                              <Grid container columnSpacing={2}>
                                {item.boxName == programBoxName.REFUND_PROGRAM &&
                                showRefundProgramApplication() ? (
                                  <Grid className="" item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <Typography variant="body2">Refund Program</Typography>
                                    </Stack>
                                  </Grid>
                                ) : null}
                                {item.boxName == programBoxName.NON_REFUND_PROGRAM ? (
                                  <Grid className="" item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <Typography variant="body2">
                                        Multi-Cycle Discount Program
                                      </Typography>
                                    </Stack>
                                  </Grid>
                                ) : null}
                                {item.boxName == programBoxName.PAY_PER_CYCLE ? (
                                  <Grid className="" item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <Typography variant="body2">Pay Per Cycle</Typography>
                                    </Stack>
                                  </Grid>
                                ) : null}
                              </Grid>
                              <Stack
                                className="program-summary align-center p-2"
                                sx={{ backgroundColor: "#818294", color: "#fff", width: "100%" }}>
                                <Typography variant="body2">Increased Chance of Success</Typography>
                              </Stack>
                              <Grid container columnSpacing={2}>
                                {item.boxName == programBoxName.REFUND_PROGRAM &&
                                showRefundProgramApplication() ? (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px" }}>
                                        80% of enrolled patients bring home a baby
                                      </InputLabel>
                                    </Stack>
                                  </Grid>
                                ) : null}
                                {item.boxName == programBoxName.NON_REFUND_PROGRAM && (
                                  <Grid item xs={12} lgxs={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px", px: 3 }}>
                                        80% of enrolled patients bring home a baby
                                      </InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                                {item.boxName == programBoxName.PAY_PER_CYCLE && (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <DisabledByDefaultOutlined
                                        color="primary"
                                        sx={{ color: "#1BA3AD" }}
                                      />
                                      <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                              </Grid>
                              <Stack
                                className="program-summary align-center p-2"
                                sx={{ backgroundColor: "#818294", width: "100%", color: "#fff" }}>
                                <Typography variant="body2">Refund Available</Typography>
                              </Stack>
                              <Grid container columnSpacing={2}>
                                {item.boxName == programBoxName.REFUND_PROGRAM &&
                                showRefundProgramApplication() ? (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px" }}>
                                        Refund If you don&apos;t bring home a baby
                                      </InputLabel>
                                    </Stack>
                                  </Grid>
                                ) : null}
                                {item.boxName == programBoxName.NON_REFUND_PROGRAM && (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <DisabledByDefaultOutlined
                                        color="primary"
                                        sx={{ color: "#1BA3AD" }}
                                      />
                                      <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                                {item.boxName == programBoxName.PAY_PER_CYCLE && (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <DisabledByDefaultOutlined
                                        color="primary"
                                        sx={{ color: "#1BA3AD" }}
                                      />
                                      <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                              </Grid>
                              <Stack
                                className="program-summary align-center p-2"
                                sx={{ backgroundColor: "#818294", width: "100%", color: "#fff" }}>
                                <Typography variant="body2">Egg Retrievals</Typography>
                              </Stack>
                              <Grid container columnSpacing={2}>
                                {/* {fapCardsStore.programVisualization &&
                              fapCardsStore.programVisualization.map((item, index) => {
                                return ( */}
                                {item.boxName == programBoxName.REFUND_PROGRAM ? (
                                  props?.cardData?.refundApplicationStatus !=
                                    "Rejected Not Medically Appropriate" &&
                                  props?.cardData?.refundApplicationStatus !=
                                    "Rejected Incomplete" ? (
                                    <Grid item xs={12} lg={xsValue} key={index}>
                                      <Stack className="compare-details-items align-center">
                                        <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                        <InputLabel sx={{ fontSize: "12px" }}>
                                          {getRetrievals(item) + " Retrievals"}
                                        </InputLabel>
                                      </Stack>
                                    </Grid>
                                  ) : null
                                ) : (
                                  <Grid item xs={12} lg={xsValue} key={index}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px" }}>
                                        {getRetrievals(item) + " Retrievals"}
                                      </InputLabel>
                                    </Stack>
                                  </Grid>
                                )}

                                {/*  );
                              })} */}
                              </Grid>
                              <Stack
                                className="program-summary align-center p-2"
                                sx={{ backgroundColor: "#818294", width: "100%", color: "#fff" }}>
                                <Typography variant="body2">
                                  Unlimited Frozen Embryo Transfers
                                </Typography>
                              </Stack>
                              <Grid container columnSpacing={2}>
                                {item.boxName == programBoxName.REFUND_PROGRAM &&
                                showRefundProgramApplication() ? (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                                    </Stack>
                                  </Grid>
                                ) : null}
                                {item.boxName == programBoxName.NON_REFUND_PROGRAM && (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                      <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                                {item.boxName == programBoxName.PAY_PER_CYCLE && (
                                  <Grid item xs={12} lg={xsValue}>
                                    <Stack className="compare-details-items align-center">
                                      <DisabledByDefaultOutlined
                                        color="primary"
                                        sx={{ color: "#1BA3AD" }}
                                      />
                                      <InputLabel sx={{ fontSize: "12px" }}>
                                        Payment of{" "}
                                        {fapCardsStore &&
                                          fapCardsStore.globalPriceOfFet &&
                                          "$" +
                                            fapCardsStore.globalPriceOfFet.toLocaleString(
                                              "en"
                                            )}{" "}
                                        required for each FET
                                      </InputLabel>
                                    </Stack>
                                  </Grid>
                                )}
                              </Grid>
                            </>
                          ) : null}
                        </>
                      );
                    })}
                </Grid>

                {!isMobileView ? (
                  cardData?.treatmentType.toString().toLowerCase().includes("ivf") ? (
                    <>
                      <Stack
                        className="align-center compare-details"
                        sx={{ backgroundColor: "#1BA3AD", color: "#FFF" }}>
                        <Typography>Compare the Details</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        {isRefundProgram && showRefundProgramApplication() ? (
                          <Grid className="" item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <Typography variant="body2">Refund Program</Typography>
                            </Stack>
                          </Grid>
                        ) : null}
                        {isNonRefundProgram ? (
                          <Grid className="" item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <Typography variant="body2">Multi-Cycle Discount Program</Typography>
                            </Stack>
                          </Grid>
                        ) : null}
                        {isSingleCycle ? (
                          <Grid className="" item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <Typography variant="body2">Pay Per Cycle</Typography>
                            </Stack>
                          </Grid>
                        ) : null}
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Increased Chance of Success</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        {isRefundProgram && showRefundProgramApplication() ? (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                              <InputLabel sx={{ fontSize: "12px" }}>
                                80% of enrolled patients bring home a baby
                              </InputLabel>
                            </Stack>
                          </Grid>
                        ) : null}
                        {isNonRefundProgram && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                              <InputLabel sx={{ fontSize: "12px", px: 3 }}>
                                80% of enrolled patients bring home a baby
                              </InputLabel>
                            </Stack>
                          </Grid>
                        )}
                        {isSingleCycle && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <DisabledByDefaultOutlined
                                color="primary"
                                sx={{ color: "#1BA3AD" }}
                              />
                              <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                            </Stack>
                          </Grid>
                        )}
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Refund Available</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        {isRefundProgram && showRefundProgramApplication() ? (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                              <InputLabel sx={{ fontSize: "12px" }}>
                                Refund If you don&apos;t bring home a baby
                              </InputLabel>
                            </Stack>
                          </Grid>
                        ) : null}
                        {isNonRefundProgram && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <DisabledByDefaultOutlined
                                color="primary"
                                sx={{ color: "#1BA3AD" }}
                              />
                              <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                            </Stack>
                          </Grid>
                        )}
                        {isSingleCycle && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <DisabledByDefaultOutlined
                                color="primary"
                                sx={{ color: "#1BA3AD" }}
                              />
                              <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                            </Stack>
                          </Grid>
                        )}
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Egg Retrievals</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        {fapCardsStore.programVisualization &&
                          fapCardsStore.programVisualization.map((item, index) => {
                            return item?.boxName == "Refund Program" ? (
                              showRefundProgramApplication() ? (
                                <Grid item xs={12} lg={xsValue} key={index}>
                                  <Stack className="compare-details-items align-center">
                                    <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                    <InputLabel sx={{ fontSize: "12px" }}>
                                      {getRetrievals(item) + " Retrievals"}
                                    </InputLabel>
                                  </Stack>
                                </Grid>
                              ) : null
                            ) : (
                              <Grid item xs={12} lg={xsValue} key={index}>
                                <Stack className="compare-details-items align-center">
                                  <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                                  <InputLabel sx={{ fontSize: "12px" }}>
                                    {getRetrievals(item) + " Retrievals"}
                                  </InputLabel>
                                </Stack>
                              </Grid>
                            );
                          })}
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Unlimited Frozen Embryo Transfers</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        {isRefundProgram && showRefundProgramApplication() ? (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                              <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                            </Stack>
                          </Grid>
                        ) : null}
                        {isNonRefundProgram && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <CheckBoxSharp color="primary" sx={{ color: "#1BA3AD" }} />
                              <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                            </Stack>
                          </Grid>
                        )}
                        {isSingleCycle && (
                          <Grid item xs={12} lg={xsValue}>
                            <Stack className="compare-details-items align-center">
                              <DisabledByDefaultOutlined
                                color="primary"
                                sx={{ color: "#1BA3AD" }}
                              />
                              <InputLabel sx={{ fontSize: "12px" }}>
                                Payment of{" "}
                                {fapCardsStore &&
                                  fapCardsStore.globalPriceOfFet &&
                                  "$" + fapCardsStore.globalPriceOfFet.toLocaleString("en")}{" "}
                                required for each FET
                              </InputLabel>
                            </Stack>
                          </Grid>
                        )}
                      </Grid>
                    </>
                  ) : cardData?.treatmentType.toString().toLowerCase().includes("fp") ? (
                    <>
                      <Stack
                        className="align-center compare-details"
                        sx={{ backgroundColor: "#1BA3AD", color: "#FFF" }}>
                        <Typography>Compare the Details</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        <Grid className="" item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <Typography variant="body2">ASSURE 20</Typography>
                          </Stack>
                        </Grid>

                        <Grid className="" item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <Typography variant="body2">ASSURE 30</Typography>
                          </Stack>
                        </Grid>

                        <Grid className="" item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <Typography variant="body2">Pay Per Cycle</Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Cost</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px" }}>{assure20Price}</InputLabel>
                          </Stack>
                        </Grid>

                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px", px: 3 }}>
                              {assure30Price}
                            </InputLabel>
                          </Stack>
                        </Grid>

                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px", px: 3 }}>
                              {oneCyclePrice}
                            </InputLabel>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Stack
                        className="program-summary align-center p-2"
                        sx={{ backgroundColor: "#818294", color: "#fff" }}>
                        <Typography variant="body2">Guarantee</Typography>
                      </Stack>
                      <Grid container columnSpacing={2}>
                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px" }}>
                              Assure 20: Up to 4 cycles or 20 mature eggs, whichever occurs first
                            </InputLabel>
                          </Stack>
                        </Grid>

                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px" }}>
                              Assure 30: Up to 5 cycles or 30 mature eggs, whichever occurs first
                            </InputLabel>
                          </Stack>
                        </Grid>

                        <Grid item xs={xsFpValue}>
                          <Stack className="compare-details-items align-center">
                            <InputLabel sx={{ fontSize: "12px" }}>None</InputLabel>
                            <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                          </Stack>
                        </Grid>
                      </Grid>
                      {!cardData?.treatmentType.toString().toLowerCase().includes("fp") && (
                        <>
                          <Stack
                            className="program-summary align-center p-2"
                            sx={{ backgroundColor: "#818294", color: "#fff" }}>
                            <Typography variant="body2">Refund</Typography>
                          </Stack>
                          <Grid container columnSpacing={2}>
                            <Grid item xs={xsFpValue}>
                              <Stack className="compare-details-items align-center">
                                <InputLabel sx={{ fontSize: "12px" }}>
                                  $3,000 refund if 20 mature eggs are retrieved during first cycle
                                </InputLabel>
                              </Stack>
                            </Grid>

                            <Grid item xs={xsFpValue}>
                              <Stack className="compare-details-items align-center">
                                <InputLabel sx={{ fontSize: "12px" }}>
                                  $8,000 refund if 30 mature eggs are retrieved during first cycle
                                </InputLabel>
                                <InputLabel sx={{ fontSize: "12px" }}>
                                  $3,000 refund If 30 mature eggs are retrieved after two cycles
                                </InputLabel>
                              </Stack>
                            </Grid>

                            <Grid item xs={xsFpValue}>
                              <Stack className="compare-details-items align-center">
                                <InputLabel sx={{ fontSize: "12px" }}>None</InputLabel>
                                <InputLabel sx={{ fontSize: "12px" }}>&nbsp;</InputLabel>
                              </Stack>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </>
                  ) : null
                ) : null}
              </Card>
              <Stack>
                <Typography py={2}>
                  <b className="loan-disclaimer">Loan term Disclaimer :</b> {loanDisclaimer}
                </Typography>
              </Stack>
            </Box>
          </Box>
        </>
      ) : null}
    </>
  );
};
export default FapView;
